export const SET_OPTIONS = 'setOptions';
export const SET_STATE = 'setState';
export const SET_FILTERS = 'setFilters';
export const FETCH_DATA = 'fetchData';
